import React from 'react';
import Form from 'react-bootstrap/Form';

const CustomSelect = ({
    options = [],
    value = '',
    onChange,
    placeholder = 'Selecionar empresa',
    ariaLabel = 'select-default',
    className = '',
    size = 'sm',
    style = {},
    ...rest
}) => {
    const sizeClass = size === 'sm' ? 'form-select-sm' : '';

    return (
        <Form.Select
            aria-label={ariaLabel}
            className={`${sizeClass} ${className}`}
            value={value}
            onChange={onChange}
            style={{ fontSize: '0.85rem', padding: '0.4rem 0.75rem', ...style }}
            {...rest}
        >
            <option value="">{placeholder}</option>
            {options.map((opt) => (
                <option key={opt.value} value={opt.value}>
                    {opt.label}
                </option>
            ))}
        </Form.Select>
    );
};

export default CustomSelect;
